module.exports = __webpack_public_path__ + "img/hochvogel.f51b856e.jpg";